import { zhCN, de, enUS, es, fr, ko, pt, ptBR, ru, tr, ja, cs, pl, zhTW } from 'date-fns/locale';

export const defaultLocale = 'en';

export const locales = {
  en: { lang: enUS, format: 'd MMMM, yyyy', shortFormat: 'd. MMM' },
  de: { lang: de, format: 'dd.MM.yyyy', shortFormat: 'd. MMM' },
  es: { lang: es, format: 'dd/MM/yyyy', shortFormat: 'd. MMM' },
  fr: { lang: fr, format: 'dd/MM/yyyy', shortFormat: 'd. MMM' },
  pt: { lang: pt, format: 'dd/MM/yyyy', shortFormat: 'd. MMM' },
  bp: { lang: ptBR, format: 'dd/MM/yyyy', shortFormat: 'd. MMM' },
  ru: { lang: ru, format: 'd MMM yyyy', shortFormat: 'd. MMM' },
  tr: { lang: tr, format: 'dd.MM.yyyy', shortFormat: 'd. MMM' },
  zh: { lang: zhCN, format: 'yyyy-MM-dd', shortFormat: 'd. MMM' },
  cn: { lang: zhCN, format: 'yyyy-MM-dd', shortFormat: 'd. MMM' },
  tw: { lang: zhTW, format: 'yyyy-MM-dd', shortFormat: 'd. MMM' },
  jp: { lang: ja, format: 'yyyy/MM/dd', shortFormat: 'd. MMM' },
  cz: { lang: cs, format: 'dd.MM.yyyy', shortFormat: 'd. MMM' },
  ko: { lang: ko, format: 'yyyy MM dd', shortFormat: 'd. MMM' },
  pl: { lang: pl, format: 'd.MM.yyyy', shortFormat: 'd. MMM' }
};
